import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { ICreateBatchData } from '../models/create-batch-data';
import { IFilterContracts, IFilterParams } from '../models/filters';
import { HeaderTitle, IHeaderSummary } from '../models/generic';
import { StatusBadgeTone } from '../shared/components/status-badge/status-badge.component';

export interface ISubheaderOverride {
  title: string;
  badgeLabel?: string;
  badgeTone?: StatusBadgeTone;
  backLink?: string;
  // Título simples, sem o realce em negrito dos overrides de detalhe (e sem breadcrumb da tela de origem).
  plainTitle?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class DataService {
  stageFilters = new BehaviorSubject<string[]>([]);
  statusFilter = new BehaviorSubject<string[]>([]);
  statusRepasseFilter = new BehaviorSubject<string[]>([]);
  listFilters = new BehaviorSubject<IFilterContracts>({
    Context: 'invoice',
    Status: [],
    Stages: [],
    BatchStatuses: [],
    IsLegacy: false,
    IsZeroRate: false,
    WithoutBatch: false,
    ContractBatchMode: 'all',
    RateMode: 'all',
    TransferRateMode: 'all',
    StatusOfOnlending: [],
    OrderStatus: [],
    BatchStatus: true,
    StatusProduct: []
  });
  headerInfos = new BehaviorSubject<{
    lotLinked?: string;
    lotCreated?: string;
    legacyBatchNumber?: string;
  }>({});

  listParameters = new BehaviorSubject<IFilterParams>({
    Text: []
  });

  emailModalClose = new BehaviorSubject(null);
  handleEmailModalClose = this.emailModalClose.asObservable();

  headerTitle = new Subject<HeaderTitle>();
  changeActiveTabs = new Subject<string | number>();
  headerSummary = new BehaviorSubject<IHeaderSummary[]>([]);
  subheaderOverride = new BehaviorSubject<ISubheaderOverride | null>(null);
  createBatchData = new Subject<ICreateBatchData>();
  clearContracts = new Subject();
  constructor() { }

  setStageFilters(stages: string[]): void {
    this.stageFilters.next(stages);
  }

  setStatusFilter(status: string[]): void {
    this.statusFilter.next(status);
  }

  setStatusRepasseFilter(statusRepasse: string[]) {
    this.statusRepasseFilter.next(statusRepasse);
  }

  applyFilters(filters: IFilterContracts): void {
    this.listFilters.next(filters);
  }

  setHeaderTitle(title: HeaderTitle): void {
    this.headerTitle.next(title);
  }

  setCreateBatchData(data: ICreateBatchData): void {
    this.createBatchData.next(data);
  }

  setClearContracts(): void {
    this.clearContracts.next(0);
  }


  setHeaderInfos(lotCreated?: string, lotLinked?: string, legacyBatchNumber?: string): void {
    this.headerInfos.next({ lotCreated: lotCreated, lotLinked: lotLinked, legacyBatchNumber: legacyBatchNumber });
  }

  //setLegacyBatchNumberInfos(lotCreated?: string, lotLinked?: string): void {
  //  this.headerInfos.next({ lotCreated: lotCreated, lotLinked: lotLinked });
  //}

  setHeaderSummary(summary: IHeaderSummary[]): void {
    this.headerSummary.next(summary);
  }

  setSubheaderOverride(override: ISubheaderOverride | null): void {
    this.subheaderOverride.next(override);
  }

  setListParameters(params: IFilterParams): void {
    this.listParameters.next(params);
  }

  triggerEmailModalClose(): void {
    this.emailModalClose.next(null);
  }
}
